import { FormattedMessage, useIntl } from "react-intl";

import { DuplicateWeightResolution } from "flows/Picking/utils/variablePriceBarcode";
import { Button } from "ui/Button/Button";
import { Modal, ModalProps } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

type DuplicateWeightModalProps = {
  allowAdd: boolean;
  onResolve: (resolution: DuplicateWeightResolution) => void;
} & Pick<ModalProps, "isOpen">;

export function DuplicateWeightModal({ isOpen, allowAdd, onResolve }: DuplicateWeightModalProps) {
  const intl = useIntl();

  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={() => {}}
    >
      <Modal.Content marginX="s300">
        <Modal.Header textAlign="center" paddingX="s200">
          <HeaderS>
            {intl.formatMessage({ id: "components.picking.duplicate-weight-modal.title" })}
          </HeaderS>
        </Modal.Header>
        <Modal.Body paddingY="0" paddingX="s200">
          <BodyM textAlign="center" color="grey.700">
            <FormattedMessage id="components.picking.duplicate-weight-modal.body" />
          </BodyM>
        </Modal.Body>
        <Modal.Footer padding="s200" flexDirection="column" gap="s100">
          {allowAdd && (
            <Button
              onClick={() => onResolve("ADD_WITH_SAME_WEIGHT")}
              isFullWidth
              size="lg"
              data-testid="duplicate-weight-add-btn"
            >
              <FormattedMessage id="components.picking.duplicate-weight-modal.add-item" />
            </Button>
          )}
          <Button
            onClick={() => onResolve("TRY_AGAIN")}
            isFullWidth
            size="lg"
            variant="secondary"
            data-testid="duplicate-weight-retry-btn"
          >
            <FormattedMessage id="components.picking.duplicate-weight-modal.try-again" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
